module.exports = __webpack_public_path__ + "img/FMCS2.a2c84197.png";